import React from 'react';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import AddressNameInline from './AddressNameInline';

export default class AddressName extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      name: null
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.update();
    this.storageUnsubscribe = Storage.subscribe(() => this.update());
  }

  componentDidUpdate (prevProps) {
    if (this.props.address !== prevProps.address) {
      this.update();
    }
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  update () {
    this.storageUnsubscribeHandler();
    this.setState({
      name: window.addressToNameService.getNameForAddress(this.props.address)
    });
  }

  onCopy () {
    window.notifications.showSuccess('Copied to clipboard.');
  }

  renderAddressName () {
    if (this.props.address === null) {
      return;
    }

    return (
      <CopyToClipboard text={this.props.address} onCopy={this.onCopy}>
        <span data-tip={this.props.address}>
          <AddressNameInline address={this.props.address}/>
        </span>
      </CopyToClipboard>
    );
  }

  render () {
    return (
      <span className="c-address-name">
        <ReactTooltip/>
        {this.renderAddressName()}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/AddressName.js